module.exports = __webpack_public_path__ + "font/2d0a0d8f5f173be15a67aa084db94fe6.eot";